export default __webpack_public_path__ + "static/media/mary-jane-background-mirror-3.ea92c363.png";